import { Tooltip as MuiTooltip } from "@mui/material";

export const Tooltip = MuiTooltip;
